/**
 * @description
 *
 * Проверка объекта на пустоту
 *
 * @param {object} object - объект для проверки
 *
 * @returns {boolean} - возвращает true, если объект пуст
 */

function isEmptyObject(object) {
  return typeof object === 'object' ? !Object.keys(object).length : false
}

export default isEmptyObject
